import React from "react"
import Authenticated from "../../lib/Authenticated"
import Sidebar from "../Sidebar"
import SidebarItem from "../Sidebar/SidebarItem"

export const menuLinks = () => {

  const authenticated = new Authenticated(),
  isSuper = authenticated.isSuper(),
  isAdmin = authenticated.isAdmin(),
  isAccountant = authenticated.isAccountant(),
  isPaymentManager = authenticated.isPaymentManager(),
  isSuperOrAdmin = isSuper || isAdmin,
  isAdminOrAccountant = isAdmin || isAccountant

 return [
  {
    to: '/home',
    icon: 'home',
    title: 'Home',
    authorized: true,
  },
  {
    to: '/organizations',
    icon: 'sitemap',
    title: 'Organizations',
    authorized: isSuper,
  },
  {
    to: '/users',
    icon: 'users',
    title: 'Users',
    authorized: isAdmin,
  },
  {
    to: '/businesses',
    icon: 'building-o',
    title: 'Businesses',
    authorized: !isSuper,
  },
  {
    to: '/customers',
    icon: 'address-book-o',
    title: 'Customers',
    authorized: !isSuper,
  },
  {
    to: '/loans',
    icon: 'credit-card',
    title: 'Loans',
    authorized: !isSuper,
  },
  {
    to: '/bundles',
    icon: 'bookmark',
    title: 'Bundles',
    authorized: !(isSuper || isPaymentManager),
  },
  {
    to: '/charges',
    icon: 'thumb-tack',
    title: 'Charges',
    authorized: isAdmin,
  },
  {
    to: '/accounting',
    icon: 'money',
    title: 'Accounting',
    authorized: isAdminOrAccountant,
  },
  {
    to: '/financiers',
    icon: 'underline',
    title: 'Financiers',
    authorized: isAdminOrAccountant,
  },
  {
    to: '/update',
    icon: 'cloud-upload',
    title: 'Update',
    authorized: isSuperOrAdmin,
  },
  {
    to: '/batches',
    icon: 'mobile',
    title: 'Devices',
    authorized: isAdmin,
  },
  {
    to: '/import',
    icon: 'upload',
    title: 'Import',
    authorized: isAdmin,
  },
  {
    to: '/settings',
    icon: 'sliders',
    title: 'Settings',
    authorized: isSuperOrAdmin,
  }]
}

export default function MenuLeft() {

  return (
    <Sidebar>
      { menuLinks().map(({ to, icon, title, authorized }, index) => authorized && 
        <SidebarItem key={ index } to={ to } icon={ icon } title={ title }>
          { title }
        </SidebarItem>
      )}
    </Sidebar>
  )
}



// WEBPACK FOOTER //
// ./src/components/App/MenuLeft.js